import { useState } from 'react';
import { commentsData, faqData, contactData, appData } from '@/mocks/homeData';

export default function SectionsFour() {
  return (
    <>
      <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              影迷心声
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              听听其他8090影迷的真实感受，这里聚集了一群热爱老电影的人
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {commentsData.map((comment) => (
              <CommentCard key={comment.id} comment={comment} />
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-20">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              关于8090影院的使用、片库、画质等常见疑问，这里都有答案
            </p>
          </div>

          <div className="space-y-3">
            {faqData.map((faq) => (
              <FaqItem key={faq.id} faq={faq} />
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto mb-8">
            {contactData.desc}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200 min-w-[200px]">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-700">{contactData.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200 min-w-[200px]">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">微信公众号</div>
                <div className="text-sm font-medium text-foreground-700">{contactData.wechat}</div>
              </div>
            </div>

            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200 min-w-[200px]">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 shrink-0">
                <i className="ri-qq-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400">QQ群</div>
                <div className="text-sm font-medium text-foreground-700">{contactData.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="app" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                {appData.desc}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="px-5 py-2.5 bg-foreground-950 text-background-50 rounded-lg text-sm font-medium flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  添加到主屏幕
                </div>
                <div className="px-5 py-2.5 bg-background-100 text-foreground-700 rounded-lg text-sm font-medium flex items-center gap-2 border border-background-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  浏览器打开
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-sm lg:max-w-none">
              <AppImage />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

function CommentCard({ comment }: { comment: typeof commentsData[0] }) {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-5 hover:border-secondary-200 transition-colors duration-200">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 shrink-0">
          <img
            src={comment.avatar}
            alt={comment.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              const target = e.currentTarget;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent) {
                const icon = document.createElement('i');
                icon.className = 'ri-user-line text-lg text-secondary-500';
                parent.style.display = 'flex';
                parent.style.alignItems = 'center';
                parent.style.justifyContent = 'center';
                parent.appendChild(icon);
              }
            }}
            loading="lazy"
          />
        </div>
        <div>
          <div className="text-sm font-semibold text-foreground-950">{comment.name}</div>
          <div className="text-xs text-foreground-400">{comment.date}</div>
        </div>
      </div>
      <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
    </div>
  );
}

function FaqItem({ faq }: { faq: typeof faqData[0] }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
      >
        <h3 className="font-heading text-sm font-semibold text-foreground-950 pr-4">{faq.question}</h3>
        <div className="w-6 h-6 flex items-center justify-center shrink-0">
          <i className={`text-lg text-foreground-400 transition-transform duration-200 ${open ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
        </div>
      </button>
      {open && (
        <div className="px-4 pb-4">
          <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

function AppImage() {
  const [error, setError] = useState(false);
  if (error) return null;
  return (
    <div className="relative w-full max-w-[280px] mx-auto aspect-[5/6] rounded-2xl overflow-hidden border-4 border-background-200">
      <img
        src={appData.image}
        alt="8090影院移动端观影体验"
        className="w-full h-full object-cover"
        onError={() => setError(true)}
        loading="lazy"
      />
    </div>
  );
}